import React, { useEffect, useState } from "react";
import GlobalHeader from "../../components/header";
import Footer from "../../components/footer";
import {
  Stack,
  Typography,
  Stepper,
  Step,
  StepLabel,
  Button,
  TextField,
  Box,
  FormControlLabel,
  Checkbox,
  Backdrop,
  CircularProgress,
  InputAdornment,
} from "@mui/material";
import {
  buttonStepsStyle,
  inputInvertirStyle,
  titleInvertStyle,
} from "../../styles";
import { ArrowForwardIos } from "@mui/icons-material";
import SnackAlert from "../../components/SnackAlert";
import useSnack from "../../hooks/useSnack";
import useApi from "../../hooks/useApi";
import { Link, useParams, useNavigate } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import DropZone from "../../components/DropZone";
import CheckImg from "../../images/check-mark.svg";
import EuroIcon from "@mui/icons-material/Euro";
import PhoneIcon from "@mui/icons-material/Phone";
// import DropZoneComponent from "../../components/DropZone";

function InvestedSuccess() {
  return (
    <Stack>
      <Box
        sx={{
          width: { xs: 110, sm: 120, lg: 130 },
          textAlign: "center",
          marginInline: "auto",
          mb: 2,
        }}
      >
        <img src={CheckImg} style={{ width: "100%", height: "100%" }} />
      </Box>
      <Typography
        fontSize="large"
        sx={{
          fontWeight: "normal",
          textAlign: "center",
          width: { xs: "90%", md: "50%" },
          marginInline: "auto",
          mb: 4,
        }}
      >
        Listo, se han enviado tus documentos a revisión. Pronto nos
        contactaremos contigo para informarte del estado. ¡Gracias por usar
        Invirte!
      </Typography>
      <Button
        variant="contained"
        LinkComponent={Link}
        to={"/"}
        sx={{
          width: "fit-content",
          px: 4,
          marginInline: "auto",
          color: "white",
        }}
      >
        REGRESAR
      </Button>
    </Stack>
  );
}

function Invertir() {
  const [nameBussiness, setNameBussiness] = useState(false);
  const [backdrop, setBackdrop] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [invested, setInvested] = useState();
  const [investmentAmount, setInvestmentAmount] = useState("");
  const [acceptTerms, setAcceptTerms] = useState("off");
  const [phoneContact, setPhoneContact] = useState("");
  const { msgSB, openSB, showSnack, typeSB } = useSnack();
  const { loadApi, loadingApi } = useApi();
  const [isLoading, setIsLoading] = useState(false);
  const [fileSelected, setFileSelected] = useState();
  const steps = ["INVERTIR", "FIRMAR", "TRANSFERIR"];

  const params = useParams();
  const navigate = useNavigate();

  const handleInvest = () => {
    setIsLoading(true);

    loadApi(
      `investment/${params.id}`,
      true,
      "post",
      {
        invested_value: investmentAmount,
        phone: phoneContact,
        document: fileSelected,
      },
      true
    )
      .then((response) => {
        setInvested(true);
      })
      .catch((e) => showSnack(e.message))
      .finally(() => setIsLoading(false));
  };

  const handlerClickNext = async () => {
    if (activeStep === 0) {
      if (phoneContact === "" || investmentAmount === "") {
        showSnack("Debe llenar todos los campos");
        return;
      }

      if (parseFloat(investmentAmount) < 1) {
        showSnack("La inversión no puede ser cero");
        return;
      }

      try {
        setBackdrop(true);

        await loadApi(`investment/validate/${params.id}`, true, "post", {
          invested_value: investmentAmount,
        });
      } catch (error) {
        showSnack(error.message || "An error occurred");
        return false;
      } finally {
        setBackdrop(false);
      }
    }

    if (activeStep === 1) {
      if (acceptTerms === "off") {
        showSnack("Debes aceptar los términos");
        setActiveStep(1);
        return;
      }
    }

    if (activeStep !== 2) {
      setActiveStep(activeStep + 1);
      return;
    }
  };

  const formatNumberWithDots = (number) => {
    return number.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };
  const handleChange = (value) => {
    const rawValue = value.replace(/\./g, "");
    return rawValue;
  };

  useEffect(() => {
    setBackdrop(true);
    loadApi(`project/${params.id}`, true, "get")
      .then((response) => {
        if (response.data.project.verified !== "approved") {
          navigate("/projects");
          return;
        }
        setNameBussiness(response.data.project.name_business);
      })
      .catch((e) => {
        showSnack(e.message, "error", 5000);
      })
      .finally(() => {
        setBackdrop(false);
      });
  }, []);

  return (
    <>
      <GlobalHeader />
      <Stack
        sx={{
          width: {
            xs: "100vw",
            md: "75vw",
            lg: "75vw",
          },
          pt: 2,
          minHeight: "90vh",
          backgroundColor: "white",
          marginInline: "auto",
          justifyContent: "center",
          placeContent: invested ? "center" : "initial",
        }}
      >
        {invested ? (
          <InvestedSuccess />
        ) : (
          <Stack px={{ xs: 2, md: 4 }} py={{ xs: 5, md: 0 }}>
            <Stack
              component="section"
              sx={{ mb: 5, textAlign: { xs: "center", lg: "left" } }}
            >
              <Typography variant="h4" sx={{ ...titleInvertStyle }}>
                INVIERTE
              </Typography>
              <Typography
                variant="h5"
                noWrap
                sx={{
                  ...titleInvertStyle,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  width: "100%",
                }}
              >
                {nameBussiness}
              </Typography>
            </Stack>
            <Stack
              component="form"
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              {/* STEPPER */}
              <Stepper
                activeStep={activeStep}
                sx={{
                  mb: 4,
                  "& .MuiStepConnector-line": {
                    border: "2px solid #002B44",
                  },
                  "& .MuiStepIcon-text": {
                    fill: "white !important",
                  },
                }}
              >
                {(steps || []).map((label, id) => {
                  const stepProps = {};
                  const labelProps = {};
                  return (
                    <Step
                      key={id}
                      {...stepProps}
                      sx={{
                        color: "white !important",
                        "& .MuiStepLabel-root .MuiStepIcon-root": {
                          color: "primary.main",
                        },
                      }}
                    >
                      <StepLabel {...labelProps}>{label}</StepLabel>
                    </Step>
                  );
                })}
              </Stepper>

              {/* COMPONENTS STEPS */}
              {activeStep === 0 ? (
                <Stack component="article" sx={{ px: 2 }}>
                  <Stack
                    sx={{
                      flexDirection: {
                        xs: "column",
                        sm: "row",
                        lg: "row",
                      },
                      justifyContent: "space-around",
                    }}
                  >
                    <TextField
                      id="amount-investment"
                      type="text"
                      label="Tu inversión"
                      autoComplete="off"
                      value={formatNumberWithDots(investmentAmount)}
                      onChange={({ target }) => {
                        let result = handleChange(target.value);
                        if (result.startsWith("-") || result.startsWith("0")) {
                          return;
                        }
                        if (/^\d*$/.test(result)) {
                          result = result.slice(0, 10);

                          setInvestmentAmount(result);
                        }
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <EuroIcon />
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        ...inputInvertirStyle,
                      }}
                    />
                    <TextField
                      type="tel"
                      id="phone-contact"
                      label="Teléfono"
                      value={phoneContact}
                      onChange={(e) => {
                        let result = handleChange(e.target.value);
                        if (result.startsWith("-") || result.startsWith("0")) {
                          return;
                        }
                        if (result.length > 20) {
                          return;
                        }
                        if (/^\d*$/.test(result)) {
                          setPhoneContact(result);
                        }
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <PhoneIcon />
                          </InputAdornment>
                        ),
                      }}
                      sx={{ ...inputInvertirStyle }}
                    />
                  </Stack>
                </Stack>
              ) : activeStep === 1 ? (
                <Stack component="article" sx={{ px: 2 }}>
                  <Box>
                    <Typography
                      component="p"
                      sx={{ fontWeight: "bold", fontSize: "large" }}
                    >
                      Política de Aceptación de Términos y Condiciones
                    </Typography>
                    <Typography
                      component="p"
                      sx={{ fontWeight: "bold", fontSize: "large" }}
                    >
                      Plataforma de Inversión “Invirte”
                    </Typography>
                    <br />
                    <Typography
                      component="p"
                      sx={{ fontWeight: "regular", marginBottom: 2 }}
                    >
                      1. <strong>Objeto de la Política</strong>
                    </Typography>
                    <Typography
                      component="p"
                      sx={{ fontWeight: "regular", marginBottom: 2 }}
                    >
                      La presente Política de Aceptación de Términos y
                      Condiciones regula el proceso mediante el cual los
                      usuarios aceptan las normas de uso, obligaciones y
                      responsabilidades asociadas al acceso y utilización de la
                      plataforma de inversión Invirte (en adelante, “la
                      Plataforma”).
                    </Typography>
                    <Typography
                      component="p"
                      sx={{ fontWeight: "regular", marginBottom: 2 }}
                    >
                      2.{" "}
                      <strong>
                        Aceptación Explícita por Parte del Usuario
                      </strong>
                    </Typography>
                    <Typography
                      component="p"
                      sx={{ fontWeight: "regular", marginBottom: 2 }}
                    >
                      Para utilizar la Plataforma, el usuario deberá aceptar de
                      manera expresa, informada y voluntaria los Términos y
                      Condiciones vigentes. Esta aceptación se realizará
                      mediante:
                    </Typography>
                    <ul>
                      <li>
                        Marcado de una casilla (“checkbox”) habilitada para tal
                        fin.
                      </li>
                      <li>
                        Pulsación de un botón como “Acepto” o “Registrar
                        cuenta”.
                      </li>
                      <li>
                        Acciones equivalentes que impliquen consentimiento
                        explícito.
                      </li>
                    </ul>
                    <Typography
                      component="p"
                      sx={{ fontWeight: "regular", marginBottom: 2 }}
                    >
                      Sin esta aceptación, el usuario no podrá registrarse ni
                      operar dentro de la Plataforma.
                    </Typography>
                    <Typography
                      component="p"
                      sx={{ fontWeight: "regular", marginBottom: 2 }}
                    >
                      3. <strong>Momento de la Aceptación</strong>
                    </Typography>
                    <Typography
                      component="p"
                      sx={{ fontWeight: "regular", marginBottom: 2 }}
                    >
                      La aceptación de los Términos y Condiciones será
                      requerida:
                    </Typography>
                    <ul>
                      <li>Durante el proceso de registro inicial.</li>
                      <li>
                        Cada vez que se realice una modificación sustancial de
                        los mismos.
                      </li>
                      <li>
                        Al acceder a servicios o productos específicos que
                        requieran condiciones adicionales.
                      </li>
                    </ul>
                    <Typography
                      component="p"
                      sx={{ fontWeight: "regular", marginBottom: 2 }}
                    >
                      4.{" "}
                      <strong>
                        Disponibilidad de los Términos y Condiciones
                      </strong>
                    </Typography>
                    <Typography
                      component="p"
                      sx={{ fontWeight: "regular", marginBottom: 2 }}
                    >
                      Antes de aceptar, el usuario tendrá acceso permanente y
                      gratuito a:
                    </Typography>
                    <ul>
                      <li>Los Términos y Condiciones completos.</li>
                      <li>La Política de Privacidad y Protección de Datos.</li>
                      <li>La Política de Riesgos de Inversión.</li>
                      <li>
                        Información sobre comisiones, gastos y funcionamiento de
                        los productos ofrecidos.
                      </li>
                    </ul>
                    <Typography
                      component="p"
                      sx={{ fontWeight: "regular", marginBottom: 2 }}
                    >
                      La documentación se mostrará de forma clara, legible y
                      descargable en formato PDF.
                    </Typography>
                    <Typography
                      component="p"
                      sx={{ fontWeight: "regular", marginBottom: 2 }}
                    >
                      5. <strong>Modificaciones y Actualizaciones</strong>
                    </Typography>
                    <Typography
                      component="p"
                      sx={{ fontWeight: "regular", marginBottom: 2 }}
                    >
                      La Plataforma podrá actualizar los Términos y Condiciones
                      cuando sea necesario. En dicho caso:
                    </Typography>
                    <ul>
                      <li>
                        Se notificará al usuario por correo electrónico o
                        mediante aviso en la Plataforma.
                      </li>
                      <li>
                        La continuidad del uso requerirá la nueva aceptación
                        explícita.
                      </li>
                      <li>
                        Si el usuario rechaza las modificaciones, podrá
                        solicitar la cancelación de su cuenta.
                      </li>
                    </ul>
                    <Typography
                      component="p"
                      sx={{ fontWeight: "regular", marginBottom: 2 }}
                    >
                      6. <strong>Registro y Evidencia de Aceptación</strong>
                    </Typography>
                    <Typography
                      component="p"
                      sx={{ fontWeight: "regular", marginBottom: 2 }}
                    >
                      La Plataforma conservará evidencia verificable de la
                      aceptación de los Términos y Condiciones por parte del
                      usuario, incluyendo:
                    </Typography>
                    <ul>
                      <li>Fecha y hora exacta (timestamp).</li>
                      <li>Versión del documento aceptado.</li>
                      <li>
                        Dirección IP o identificadores técnicos del dispositivo.
                      </li>
                    </ul>
                    <Typography
                      component="p"
                      sx={{ fontWeight: "regular", marginBottom: 2 }}
                    >
                      Esta información será custodiada conforme a la normativa
                      aplicable.
                    </Typography>
                    <Typography
                      component="p"
                      sx={{ fontWeight: "regular", marginBottom: 2 }}
                    >
                      7.{" "}
                      <strong>Rechazo o Revocación del Consentimiento</strong>
                    </Typography>
                    <Typography
                      component="p"
                      sx={{ fontWeight: "regular", marginBottom: 2 }}
                    >
                      El usuario podrá revocar su consentimiento en cualquier
                      momento, lo que implicará:
                    </Typography>
                    <ul>
                      <li>Cierre de su cuenta.</li>
                      <li>
                        Imposibilidad de seguir operando en la Plataforma.
                      </li>
                      <li>
                        Liquidación o traslado de inversiones según la normativa
                        vigente.
                      </li>
                    </ul>
                    <Typography
                      component="p"
                      sx={{ fontWeight: "regular", marginBottom: 2 }}
                    >
                      8. <strong>Contacto para Consultas</strong>
                    </Typography>
                    <Typography
                      component="p"
                      sx={{ fontWeight: "regular", marginBottom: 2 }}
                    >
                      Para cualquier duda relativa a los Términos y Condiciones
                      o al proceso de aceptación, el usuario podrá comunicarse
                      con el servicio de atención al cliente de Invirte a través
                      de los canales oficiales publicados en la Plataforma.
                    </Typography>
                  </Box>
                  <Box>
                    <FormControlLabel
                      label="Aceptar términos"
                      name="agreeTerms"
                      control={
                        <Checkbox
                          checked={acceptTerms === "on" ? true : false}
                          value={acceptTerms}
                          onChange={(e) => {
                            setAcceptTerms(acceptTerms === "on" ? "off" : "on");
                          }}
                        />
                      }
                    />
                  </Box>
                </Stack>
              ) : (
                <Stack component="article" sx={{ px: 2 }}>
                  <DropZone
                    fileSelected={fileSelected}
                    setFileSelected={setFileSelected}
                  />
                </Stack>
              )}

              {/* ACTION BUTTONS */}
              <Stack
                component="article"
                sx={{
                  justifyContent: activeStep === 0 ? "end" : "space-between",
                  flexDirection: "row",
                  px: 2,
                  mt: 5,
                  mb: 15,
                }}
              >
                {activeStep !== 0 ? (
                  <Button
                    variant="outlined"
                    disabled={isLoading}
                    onClick={() => {
                      setActiveStep(activeStep - 1);
                    }}
                    sx={{
                      width: 150,
                      fontSize: "medium",
                      textTransform: "none",
                      px: 4,
                      py: 1,
                      borderRadius: 2,
                    }}
                  >
                    Regresar
                  </Button>
                ) : (
                  ""
                )}

                {activeStep === 2 ? (
                  <LoadingButton
                    loading={isLoading}
                    type="submit"
                    onClick={handleInvest}
                    sx={{
                      ...buttonStepsStyle,
                      width: 150,
                      px: 4,
                      py: 1,
                      borderRadius: 2,
                    }}
                  >
                    <Typography
                      component="span"
                      textAlign="center"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "row",
                        letterSpacing: "1px",
                        fontSize: "medium",
                        color: "white",
                        textTransform: "none",
                      }}
                    >
                      Invertir
                    </Typography>
                  </LoadingButton>
                ) : (
                  <Button
                    type="submit"
                    onClick={handlerClickNext}
                    sx={{
                      ...buttonStepsStyle,
                      width: 150,
                      px: 4,
                      py: 1,
                      borderRadius: 2,
                    }}
                  >
                    <Typography
                      component="span"
                      textAlign="center"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "row",
                        letterSpacing: "1px",
                        fontSize: "medium",
                        color: "white",
                        gap: 1,
                        textTransform: "none",
                      }}
                    >
                      Siguiente <ArrowForwardIos fontSize="normal" />
                    </Typography>
                  </Button>
                )}
              </Stack>
            </Stack>
          </Stack>
        )}
      </Stack>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={backdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <SnackAlert openSB={openSB} typeSB={typeSB} msgSB={msgSB} />
      <Footer />
    </>
  );
}

export default Invertir;

